module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/line-badge-aeef5247da5cbaa6c2ae9f32f5f273af.svg";